import { useQuery } from '@apollo/client/react';
import { GetCouponDocument } from '@drycut/graphql';
import { Invitation } from '@drycut/referral-components';
import { Loader } from '@drycut/ui-components';
import { useParams } from 'react-router';
import { useDocumentTitle } from 'usehooks-ts';

export function ReferralInvitation(): React.ReactElement {
  useDocumentTitle('DRYCUT - Referral');

  const { code } = useParams() as { code: string };
  const { data, loading } = useQuery(GetCouponDocument, { variables: { code } });

  if (loading) {
    return <Loader />;
  }

  return <Invitation coupon={data?.coupon ?? undefined} />;
}
